module.exports = __webpack_public_path__ + "img/hip-mesomorph-female.49d47cc2.svg";